"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_ui_1 = require("material-ui");
var recompose_1 = require("recompose");
var lodash_1 = require("lodash");
var utils_1 = require("../../utils");
var reduxFormWrappers_1 = require("./reduxFormWrappers");
var Select = function (_a) {
    var items = _a.items, valueFunction = _a.valueFunction, labelFunction = _a.labelFunction, rest = __rest(_a, ["items", "valueFunction", "labelFunction"]);
    return (react_1.default.createElement(material_ui_1.SelectField, __assign({}, rest), items.map(function (_a, i) {
        var value = _a.value, text = _a.text;
        return (react_1.default.createElement(material_ui_1.MenuItem, { key: i, value: value, primaryText: text }));
    })));
};
var compareFn = function (val1, val2) {
    return lodash_1.isObject(val1) && lodash_1.isObject(val2) ? lodash_1.get(val1, 'id') === lodash_1.get(val2, 'id') : val1 === val2;
};
var ComposedSelect = recompose_1.compose(recompose_1.pure, recompose_1.defaultProps({
    labelFunction: function (_a) {
        var label = _a.label;
        return label;
    },
    valueFunction: lodash_1.identity,
    items: [],
    onChange: lodash_1.noop,
    compareFn: compareFn,
    dropDownMenuProps: {
        maxHeight: 250,
        menuItemStyle: {
            padding: '5px',
            borderBottomStyle: 'solid',
            borderColor: '#889ac5',
            borderWidth: '1px',
            whiteSpace: 'normal',
            textIndent: '-10px',
            lineHeight: '25px',
        },
    },
}), recompose_1.mapProps(function (_a) {
    var labelFunction = _a.labelFunction, valueFunction = _a.valueFunction, items = _a.items, rest = __rest(_a, ["labelFunction", "valueFunction", "items"]);
    return (__assign({ labelFunction: utils_1.safe(labelFunction), valueFunction: utils_1.safe(valueFunction), items: items.map(function (item) { return ({
            text: labelFunction(item),
            value: valueFunction(item),
        }); }) }, rest));
}), recompose_1.mapProps(function (_a) {
    var value = _a.value, items = _a.items, valueFunction = _a.valueFunction, compareFn = _a.compareFn, rest = __rest(_a, ["value", "items", "valueFunction", "compareFn"]);
    return (__assign({ value: value ? items.map(function (item) { return item.value; }).find(function (v) { return compareFn(v, value); }) : value, items: items }, rest));
}), recompose_1.renameProp('label', 'hintText'), recompose_1.withHandlers({
    onChange: function (_a) {
        var onChange = _a.onChange;
        return function (event, index, value) { return onChange(value); };
    },
}))(Select);
exports.default = ComposedSelect;
exports.FormSelect = reduxFormWrappers_1.formWrapper(ComposedSelect);
//# sourceMappingURL=Select.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/Select.js
// module id = 947
// module chunks = 0